import NTopNBottom from '../../components/NTopNBottom'

import bannerImg from '../../assets/parentChildPhoto/banner.png'
import navColor from '../../assets/parentChildPhoto/nav/color.png'
import navBg from '../../assets/parentChildPhoto/nav/nav_bg.png'

import calcRemFn from '../calcRem'

const PROD_ID = '27650'

const navCss = {
  navWrap: {
    paddingTop: 0,
    minHeight: calcRemFn(108.5),
    backgroundImage: `url(${navColor})`,
    marginTop: calcRemFn(-1),
  },
  navCtn: {
    height: calcRemFn(108.5),
    backgroundImage: `url(${navBg})`,
  },
  topBtnLayout: {
    alignItems: 'center',
    padding: `${calcRemFn(12)} ${calcRemFn(30)} 0 ${calcRemFn(30)}`,
  },
  topBtnBaseCss: {
    width: calcRemFn(79.25),
    height: calcRemFn(83.5),
  },
  bottomBtnLayout: {
    padding: 0,
  },
  bottomBtnBaseCss: {
    width: 0,
    height: 0,
  }
}


const navData = {
  component: NTopNBottom,
  top: [
    {
      key: 'top1',
      show: true,
    },
    {
      key: 'top2',
      show: true,
    },
    {
      key: 'top3',
      show: true,
    },
    {
      key: 'top4',
      show: true,
    }
  ],
  bottom: {
    top1: [
      {
        key: '_i1',
        show: false,
      }
    ],
    top2: [
      {
        key: '_i1',
        show: false,
      }
    ],
    top3: [
      {
        key: '_i1',
        show: false,
      }
    ],
    top4: [
      {
        key: '_i1',
        show: false,
      }
    ],
  },
}

navData.top = navData.top.map((item, index) => {
  item.img = require(`../../assets/parentChildPhoto/nav/far${index + 1}.png`)
  item.img_actived = require(`../../assets/parentChildPhoto/nav/far${index + 1}_active.png`)
  return item
})

const pictureList = [
  {
    id: PROD_ID,
    type: 'blue',
    ref: 'top1_i1',
    farName: 'top1',
    sonName: '_i1',
    son: [],
    name: '泡泡鱼'
  },
  {
    id: PROD_ID,
    type: 'blue',
    ref: 'top2_i1',
    farName: 'top2',
    sonName: '_i1',
    son: [],
    name: '喵星人'
  },
  {
    id: PROD_ID,
    type: 'blue',
    ref: 'top3_i1',
    farName: 'top3',
    sonName: '_i1',
    son: [],
    name: '粉粉猪'
  },
  {
    id: PROD_ID,
    type: 'blue',
    ref: 'top4_i1',
    farName: 'top4',
    sonName: '_i1',
    son: [],
    name: '小萌星'
  },
]

pictureList.forEach((item, index) => {
  if (item.farName === 'top2') {
    item.son.push(require(`../../assets/parentChildPhoto/ctn/${index + 1}_1.jpg`))
    item.son.push(require(`../../assets/parentChildPhoto/ctn/${index + 1}_2.jpg`))
  } else {
    item.son.push(require(`../../assets/parentChildPhoto/ctn/${index + 1}_1.jpg`))
  }
})
const pictures = pictureList

const topDiff = {
  firstSon: '_i1',
  top1_i1: 10,
  top2_i1: 8,
  top3_i1: 3,
  top4_i1: 18,
}

export default {
  title: '亲子照—陪你长大，与你定格',
  bannerImg,
  navCss,
  navData,
  pictures,
  topDiff
}
